import privacyPolicyContent from "../PrivacyAssests/PrivacyPolicy.js"

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 min-h-screen p-5 flex justify-center">
      <div className="bg-gray-900 shadow-lg rounded-lg p-6 w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl">
        <div dangerouslySetInnerHTML={{ __html: privacyPolicyContent }} />
      </div>
    </div>
  );
};

export default PrivacyPolicy;

